module.exports = __webpack_public_path__ + "static/media/postcard-intro-2.8fb2045f.png";